import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/styles";
import { initAffiliateTracking } from "./utils/affiliateTracking";
import * as serviceWorker from "./serviceWorker";
import ErrorBoundary from "./Errorboundary";
import { ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import AdvancedFormat from "dayjs/plugin/advancedFormat";
import RainbowKitWrapper from "./RainbowKitProvider";

dayjs.extend(AdvancedFormat); // use plugin

initAffiliateTracking();

//getSiteConfig();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <ToastContainer
      hideProgressBar={false}
      theme="colored"
      position="top-right"
      autoClose={5000}
      newestOnTop
      closeOnClick
      pauseOnHover
    />
    <RainbowKitWrapper>
      <App />
    </RainbowKitWrapper>
  </ErrorBoundary>
);

serviceWorker.unregister();
